module.exports = __webpack_public_path__ + "static/OGWII-inwestycje-2ab4996bfc72cb0a4648bd5d55a37694.jpg";